
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { MessageSquare, DollarSign, CheckCircle, XCircle, Bell, FileText, Calendar, Wrench } from "lucide-react";

const ActivityFeed = () => {
  const activities = [
    {
      id: 1,
      type: "message",
      title: "New message from John Doe",
      description: "Regarding the website redesign project",
      time: "5 minutes ago",
      icon: <MessageSquare className="w-4 h-4 text-blue-500" />,
    },
    {
      id: 2,
      type: "payment",
      title: "Payment received",
      description: "Mobile app development milestone completed",
      time: "2 hours ago",
      icon: <DollarSign className="w-4 h-4 text-emerald-500" />,
    },
    {
      id: 3,
      type: "proposal_accepted",
      title: "Proposal accepted",
      description: "E-commerce website development",
      time: "1 day ago",
      icon: <CheckCircle className="w-4 h-4 text-green-500" />,
    },
    {
      id: 4,
      type: "proposal_rejected",
      title: "Proposal declined",
      description: "Blog migration project",
      time: "2 days ago",
      icon: <XCircle className="w-4 h-4 text-red-500" />,
    },
    {
      id: 5,
      type: "notification",
      title: "Project milestone due",
      description: "Complete the UI/UX phase",
      time: "Tomorrow",
      icon: <Bell className="w-4 h-4 text-orange-500" />,
    },
    {
      id: 6,
      type: "document",
      title: "Contract signed",
      description: "New client onboarding completed",
      time: "3 days ago",
      icon: <FileText className="w-4 h-4 text-purple-500" />,
    },
    {
      id: 7,
      type: "meeting",
      title: "Client meeting scheduled",
      description: "Project kickoff discussion",
      time: "Next week",
      icon: <Calendar className="w-4 h-4 text-indigo-500" />,
    },
    {
      id: 8,
      type: "update",
      title: "System maintenance",
      description: "Platform updates scheduled",
      time: "In 2 days",
      icon: <Wrench className="w-4 h-4 text-cyan-500" />,
    },
  ];

  return (
    <Card className="col-span-1 glass-effect">
      <CardHeader>
        <CardTitle className="flex items-center justify-between">
          Recent Activity
          <Bell className="w-5 h-5 text-blue-500" />
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4 max-h-[400px] overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-gray-200 scrollbar-track-transparent">
          {activities.map((activity) => (
            <div
              key={activity.id}
              className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer group"
            >
              <div className="mt-1 group-hover:scale-110 transition-transform">
                {activity.icon}
              </div>
              <div className="flex-1 space-y-1">
                <p className="text-sm font-medium">{activity.title}</p>
                <p className="text-xs text-gray-500">{activity.description}</p>
                <p className="text-xs text-gray-400">{activity.time}</p>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default ActivityFeed;

